var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c(
            "Aggregate",
            _vm._b(
              {
                attrs: {
                  title: "Energy Storage Systems",
                  "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                    "input",
                    "storage",
                  ]),
                  ItemConstructor: _vm.storageFactory,
                  headers: _vm.headers,
                  "copy-btn": "",
                  dense: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.active",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("v-switch", {
                          staticClass: "mt-0",
                          attrs: { dense: "", "hide-details": "" },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          model: {
                            value: item.active,
                            callback: function ($$v) {
                              _vm.$set(item, "active", $$v)
                            },
                            expression: "item.active",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.bus_id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("v-select", {
                          attrs: {
                            clearable: "",
                            items: _vm.nodeIndex,
                            label: "Connected Node",
                            "single-line": "",
                            dense: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.item.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "text-caption ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "(ID: " + data.item.value + ")"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.item.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "text-caption ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "(ID: " + data.item.value + ")"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.bus_id,
                            callback: function ($$v) {
                              _vm.$set(item, "bus_id", $$v)
                            },
                            expression: "item.bus_id",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.source",
                    fn: function (ref) {
                      var item = ref.item
                      var errors = ref.errors
                      var allowEdit = ref.allowEdit
                      return [
                        _c("v-select", {
                          attrs: {
                            items: _vm.sources,
                            "error-messages": _vm.$utils.getIfExists(errors, [
                              "source",
                              "messages",
                            ]),
                            disabled: !allowEdit || item.noDelete,
                            label: "Energy Storage System",
                            dense: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          model: {
                            value: item.source,
                            callback: function ($$v) {
                              _vm.$set(item, "source", $$v)
                            },
                            expression: "item.source",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.capacity",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("td", [
                          _vm._v(_vm._s(item.power_capacity[0]) + " MW"),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var item = ref.item
                      var errors = ref.errors
                      return [
                        _c(
                          "v-card",
                          { staticClass: "pa-2 ma-2", attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("General")]
                                    ),
                                    _c("InputGeo", {
                                      attrs: {
                                        label: "Coordinates",
                                        "map-height": "150",
                                        nullable: "",
                                        "switch-text": "Set coordinates",
                                        icon: "storage",
                                        "initial-coordinates":
                                          _vm.nodeCoordinates(item.bus_id),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.coordinates,
                                        callback: function ($$v) {
                                          _vm.$set(item, "coordinates", $$v)
                                        },
                                        expression: "item.coordinates",
                                      },
                                    }),
                                    _c("v-switch", {
                                      attrs: {
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "expansion_candidate",
                                            "messages",
                                          ]),
                                        label: "Expansion Candidate",
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.expansion_candidate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "expansion_candidate",
                                            $$v
                                          )
                                        },
                                        expression: "item.expansion_candidate",
                                      },
                                    }),
                                    _c("v-switch", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        label: _vm.schema.include_elcc.title,
                                        hint: _vm.schema.include_elcc.tooltip,
                                        "persistent-hint": "",
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.include_elcc,
                                        callback: function ($$v) {
                                          _vm.$set(item, "include_elcc", $$v)
                                        },
                                        expression: "item.include_elcc",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.technical_life.title,
                                        hint: _vm.schema.technical_life.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "technical_life",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.technical_life.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.technical_life,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "technical_life",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.technical_life",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label: _vm.schema.start_year.title,
                                        suffix: _vm.schema.start_year.unit,
                                        hint: _vm.schema.start_year.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "start_year",
                                            "messages",
                                          ]),
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.start_year,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "start_year",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.start_year",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label:
                                          _vm.schema.charging_efficiency.title,
                                        hint: _vm.schema.charging_efficiency
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "charging_efficiency",
                                            "messages",
                                          ]),
                                        suffix:
                                          _vm.schema.charging_efficiency.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.charging_efficiency,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "charging_efficiency",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.charging_efficiency",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label:
                                          _vm.schema.discharging_efficiency
                                            .title,
                                        hint: _vm.schema.discharging_efficiency
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "discharging_efficiency",
                                            "messages",
                                          ]),
                                        suffix:
                                          _vm.schema.discharging_efficiency
                                            .unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.discharging_efficiency,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "discharging_efficiency",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "item.discharging_efficiency",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label: _vm.schema.ramp_rate.title,
                                        hint: _vm.schema.ramp_rate.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "ramp_rate",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.ramp_rate.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.ramp_rate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "ramp_rate",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.ramp_rate",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label: _vm.schema.soc_min.title,
                                        hint: _vm.schema.soc_min.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "soc_min",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.soc_min.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.soc_min,
                                        callback: function ($$v) {
                                          _vm.$set(item, "soc_min", _vm._n($$v))
                                        },
                                        expression: "item.soc_min",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label: _vm.schema.soc_max.title,
                                        hint: _vm.schema.soc_max.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "soc_max",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.soc_max.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.soc_max,
                                        callback: function ($$v) {
                                          _vm.$set(item, "soc_max", _vm._n($$v))
                                        },
                                        expression: "item.soc_max",
                                      },
                                    }),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { md: "5" } },
                                          [
                                            _c("v-switch", {
                                              staticClass: "pt-3 mt-1 pr-2",
                                              attrs: {
                                                label:
                                                  _vm.schema.duration.title,
                                                hint: _vm.schema.duration
                                                  .tooltip,
                                                "error-messages":
                                                  _vm.$utils.getIfExists(
                                                    errors,
                                                    ["duration", "messages"]
                                                  ),
                                                "true-value": -1,
                                                "false-value": "0",
                                                dense: "",
                                              },
                                              model: {
                                                value: item.duration,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "duration",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.duration",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          [
                                            item.duration != -1
                                              ? _c("v-text-field", {
                                                  attrs: {
                                                    "error-messages":
                                                      _vm.$utils.getIfExists(
                                                        errors,
                                                        ["duration", "messages"]
                                                      ),
                                                    hint: _vm.schema.duration
                                                      .tooltip,
                                                    suffix:
                                                      _vm.schema.duration.unit,
                                                    type: "number",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value: item.duration,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "duration",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression: "item.duration",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("InputProfile", {
                                      attrs: {
                                        label: _vm.schema.capacity_fade.title,
                                        hint: _vm.schema.capacity_fade.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "capacity_fade",
                                          ]),
                                        "profile-type": "CAPACITY_FADE",
                                        useHeaders: [
                                          "cycle_limit",
                                          "capacity_fade",
                                        ],
                                        nullable: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.capacity_fade,
                                        callback: function ($$v) {
                                          _vm.$set(item, "capacity_fade", $$v)
                                        },
                                        expression: "item.capacity_fade",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "estimated_cycles",
                                          ]),
                                        label: "Estimated Number of Cycles",
                                        suffix: "cycles",
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.estimated_cycles,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "estimated_cycles",
                                            $$v
                                          )
                                        },
                                        expression: "item.estimated_cycles",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Metrics")]
                                    ),
                                    _c("v-switch", {
                                      attrs: {
                                        label:
                                          _vm.schema.LCOE_calculation.title,
                                        hint: _vm.schema.LCOE_calculation
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "source",
                                            "messages",
                                          ]),
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.LCOE_Calculation,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "LCOE_Calculation",
                                            $$v
                                          )
                                        },
                                        expression: "item.LCOE_Calculation",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Financial")]
                                    ),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label: _vm.schema.economic_life.title,
                                        hint: _vm.schema.economic_life.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "economic_life",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.economic_life.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.economic_life,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "economic_life",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.economic_life",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      staticClass: "my-4",
                                      attrs: {
                                        label: _vm.schema.discount.title,
                                        hint: _vm.schema.discount.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "discount",
                                            "messages",
                                          ]),
                                        placeholder:
                                          _vm.input.discount &&
                                          _vm.input.discount != null
                                            ? _vm.input.discount.toString()
                                            : "",
                                        suffix: _vm.schema.discount.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.discount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "discount",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.discount",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Costs")]
                                    ),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.schema.investment.title,
                                        hint: _vm.schema.investment.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "investment",
                                          ]),
                                        suffix: _vm.schema.investment.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.investment.items.default,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.investment,
                                        callback: function ($$v) {
                                          _vm.$set(item, "investment", $$v)
                                        },
                                        expression: "item.investment",
                                      },
                                    }),
                                    _c("v-switch", {
                                      attrs: {
                                        label: _vm.schema.ppa.title,
                                        hint: _vm.schema.ppa.tooltip,
                                        "persistent-hint": "",
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.ppa.active,
                                        callback: function ($$v) {
                                          _vm.$set(item.ppa, "active", $$v)
                                        },
                                        expression: "item.ppa.active",
                                      },
                                    }),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label:
                                              _vm.schema.ppa.properties.charging
                                                .title,
                                            hint: _vm.schema.ppa.properties
                                              .charging.tooltip,
                                            suffix: "$/MWh",
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.schema.ppa.properties.charging
                                                .profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.charging,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.ppa,
                                                "charging",
                                                $$v
                                              )
                                            },
                                            expression: "item.ppa.charging",
                                          },
                                        })
                                      : _vm._e(),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label:
                                              _vm.schema.ppa.properties
                                                .discharging.title,
                                            hint: _vm.schema.ppa.properties
                                              .discharging.tooltip,
                                            suffix: "$/MWh",
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.schema.ppa.properties
                                                .discharging.profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.discharging,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.ppa,
                                                "discharging",
                                                $$v
                                              )
                                            },
                                            expression: "item.ppa.discharging",
                                          },
                                        })
                                      : _vm._e(),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label:
                                              _vm.schema.ppa.properties.capacity
                                                .title,
                                            hint: _vm.schema.ppa.properties
                                              .capacity.tooltip,
                                            suffix: "$/MW-month",
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.schema.ppa.properties.capacity
                                                .profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.capacity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.ppa,
                                                "capacity",
                                                $$v
                                              )
                                            },
                                            expression: "item.ppa.capacity",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("InputYearly", {
                                      attrs: {
                                        label:
                                          _vm.schema.investment_energy.title,
                                        hint: _vm.schema.investment_energy
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "investment_energy",
                                          ]),
                                        suffix: _vm.schema.investment.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.investment_energy.items
                                            .default,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.investment_energy,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "investment_energy",
                                            $$v
                                          )
                                        },
                                        expression: "item.investment_energy",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.schema.vom.title,
                                        hint: _vm.schema.vom.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "vom",
                                          ]),
                                        suffix: _vm.schema.vom.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.vom.items.default,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.vom,
                                        callback: function ($$v) {
                                          _vm.$set(item, "vom", $$v)
                                        },
                                        expression: "item.vom",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.fom.title,
                                        hint: _vm.schema.fom.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "fom",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.fom.unit,
                                        type: "number",
                                        min: _vm.schema.fom.minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.fom,
                                        callback: function ($$v) {
                                          _vm.$set(item, "fom", _vm._n($$v))
                                        },
                                        expression: "item.fom",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.eol_cost.title,
                                        suffix: _vm.schema.eol_cost.unit,
                                        type: "number",
                                        min: _vm.schema.eol_cost.minimum,
                                      },
                                      model: {
                                        value: item.eol_cost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "eol_cost",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.eol_cost",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Services")]
                                    ),
                                    _c("InputYearly", {
                                      attrs: {
                                        label:
                                          _vm.schema.energy_arbitrage.title,
                                        hint: _vm.schema.energy_arbitrage
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "energy_arbitrage",
                                          ]),
                                        suffix:
                                          _vm.schema.energy_arbitrage.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.energy_arbitrage.items
                                            .default,
                                        min: _vm.schema.energy_arbitrage.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.energy_arbitrage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "energy_arbitrage",
                                            $$v
                                          )
                                        },
                                        expression: "item.energy_arbitrage",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.schema.marginal_cost.title,
                                        hint: _vm.schema.marginal_cost.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "marginal_cost",
                                          ]),
                                        suffix: _vm.schema.marginal_cost.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.marginal_cost.items
                                            .default,
                                        min: _vm.schema.marginal_cost.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.marginal_cost,
                                        callback: function ($$v) {
                                          _vm.$set(item, "marginal_cost", $$v)
                                        },
                                        expression: "item.marginal_cost",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Capacity")]
                                    ),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.schema.maximum_build.title,
                                        hint: _vm.schema.maximum_build.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "maximum_build",
                                          ]),
                                        suffix: _vm.schema.maximum_build.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.maximum_build.items
                                            .default,
                                        min: _vm.schema.maximum_build.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.maximum_build,
                                        callback: function ($$v) {
                                          _vm.$set(item, "maximum_build", $$v)
                                        },
                                        expression: "item.maximum_build",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.schema.power_capacity.title,
                                        hint: _vm.schema.power_capacity.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "power_capacity",
                                          ]),
                                        suffix: _vm.schema.power_capacity.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.power_capacity.items
                                            .default,
                                        min: _vm.schema.power_capacity.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.power_capacity,
                                        callback: function ($$v) {
                                          _vm.$set(item, "power_capacity", $$v)
                                        },
                                        expression: "item.power_capacity",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.schema.energy_capacity.title,
                                        hint: _vm.schema.energy_capacity
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "energy_capacity",
                                          ]),
                                        suffix: _vm.schema.energy_capacity.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.energy_capacity.items
                                            .default,
                                        min: _vm.schema.energy_capacity.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.energy_capacity,
                                        callback: function ($$v) {
                                          _vm.$set(item, "energy_capacity", $$v)
                                        },
                                        expression: "item.energy_capacity",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.firm.title,
                                        hint: _vm.schema.firm.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "firm",
                                            "messages",
                                          ]),
                                        suffix: _vm.schema.firm.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.firm,
                                        callback: function ($$v) {
                                          _vm.$set(item, "firm", _vm._n($$v))
                                        },
                                        expression: "item.firm",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label:
                                          _vm.schema.max_charge_power.title,
                                        hint: _vm.schema.max_charge_power
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "max_charge_power",
                                          ]),
                                        suffix:
                                          _vm.schema.max_charge_power.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.max_charge_power.items
                                            .default,
                                        min: _vm.schema.max_charge_power.items
                                          .minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.max_charge_power,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "max_charge_power",
                                            $$v
                                          )
                                        },
                                        expression: "item.max_charge_power",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label:
                                          _vm.schema.max_discharge_power.title,
                                        hint: _vm.schema.max_discharge_power
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "max_discharge_power",
                                          ]),
                                        suffix:
                                          _vm.schema.max_discharge_power.unit,
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.max_discharge_power.items
                                            .default,
                                        min: _vm.schema.max_discharge_power
                                          .items.minimum,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.max_discharge_power,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "max_discharge_power",
                                            $$v
                                          )
                                        },
                                        expression: "item.max_discharge_power",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Operation")]
                                    ),
                                    _c("InputToggleParam", {
                                      attrs: {
                                        label:
                                          _vm.schema.operating_status.properties
                                            .active.title,
                                        hint: _vm.schema.operating_status
                                          .properties.active.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "operating_status",
                                          ]),
                                        "hide-divider": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var param = ref.param
                                              var errors = ref.errors
                                              return [
                                                _c("InputProfile", {
                                                  attrs: {
                                                    hint: _vm.schema
                                                      .operating_status.then
                                                      .properties.param
                                                      .properties.id.tooltip,
                                                    "error-messages":
                                                      _vm.$utils.getIfExists(
                                                        errors,
                                                        ["id"]
                                                      ),
                                                    "profile-type":
                                                      "DAILY_OPERATING_STATUS",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value: param.id,
                                                    callback: function ($$v) {
                                                      _vm.$set(param, "id", $$v)
                                                    },
                                                    expression: "param.id",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.operating_status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "operating_status",
                                            $$v
                                          )
                                        },
                                        expression: "item.operating_status",
                                      },
                                    }),
                                    _c("InputToggleParam", {
                                      attrs: {
                                        label:
                                          _vm.schema.discharge_profile
                                            .properties.active.title,
                                        hint: _vm.schema.discharge_profile
                                          .properties.active.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "discharge_profile",
                                          ]),
                                        "hide-divider": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "below",
                                            fn: function (ref) {
                                              var param = ref.param
                                              var errors = ref.errors
                                              return [
                                                _c(
                                                  "v-col",
                                                  { staticClass: "grow" },
                                                  [
                                                    _c("InputYearlyProfile", {
                                                      attrs: {
                                                        hint: _vm.schema
                                                          .discharge_profile
                                                          .properties.param
                                                          .properties.profiles
                                                          .tooltip,
                                                        "error-messages":
                                                          _vm.$utils.getIfExists(
                                                            errors,
                                                            ["profiles"]
                                                          ),
                                                        num_years:
                                                          _vm.num_years,
                                                        fill: "",
                                                        "profile-type":
                                                          "DISCHARGE",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "change"
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: param.profiles,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            param,
                                                            "profiles",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "param.profiles",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.discharge_profile,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "discharge_profile",
                                            $$v
                                          )
                                        },
                                        expression: "item.discharge_profile",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Power Flow Parameters")]
                                    ),
                                    _c("InputYearlyProfile", {
                                      attrs: {
                                        label: _vm.schema.active_power.title,
                                        suffix: _vm.schema.active_power.unit,
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.schema.active_power.items.default
                                            .value,
                                        "object-value": "",
                                        "toggle-items-type": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.active_power,
                                        callback: function ($$v) {
                                          _vm.$set(item, "active_power", $$v)
                                        },
                                        expression: "item.active_power",
                                      },
                                    }),
                                    _c("InputYearlyProfile", {
                                      attrs: {
                                        label: _vm.schema.reactive_power.title,
                                        suffix: _vm.schema.reactive_power.unit,
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "object-value": "",
                                        "toggle-items-type": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.reactive_power,
                                        callback: function ($$v) {
                                          _vm.$set(item, "reactive_power", $$v)
                                        },
                                        expression: "item.reactive_power",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.schema.scaling.title,
                                        suffix: _vm.schema.scaling.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.scaling,
                                        callback: function ($$v) {
                                          _vm.$set(item, "scaling", _vm._n($$v))
                                        },
                                        expression: "item.scaling",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.schema.max_charge_level.title,
                                        suffix:
                                          _vm.schema.max_charge_level.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.max_charge_level,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "max_charge_level",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.max_charge_level",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.computedInput.storage,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedInput, "storage", $$v)
                  },
                  expression: "computedInput.storage",
                },
              },
              "Aggregate",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }